import React, { useMemo } from "react";
import { samplePath } from "@/lib/scoring";

// LetterGuide — renders the handwriting guidelines, the (semi-transparent) letter
// guide path, the "Start Here" dot and a directional arrow. Pure SVG group meant
// to be composed inside the TracingCanvas <svg>.
export function LetterGuide({ letter, guideOpacity = 0.35, showStart = true, showLetter = true }) {
  const g = letter.guidelines;
  const vb = (letter.viewBox || "0 0 100 100").split(/\s+/).map(Number);
  const W = vb[2] || 100;
  const x1 = 2, x2 = W - 2;

  const arrow = useMemo(() => {
    const pts = samplePath(letter.strokes[0].d, 24);
    const p0 = pts[0];
    const p1 = pts[2] || pts[1];
    const angle = (Math.atan2(p1.y - p0.y, p1.x - p0.x) * 180) / Math.PI;
    return { x: p0.x, y: p0.y, angle };
  }, [letter]);

  return (
    <g>
      {/* Handwriting paper lines */}
      <line x1={x1} y1={g.top} x2={x2} y2={g.top} stroke="#DC2626" strokeWidth="0.5" opacity="0.55" />
      <line
        x1={x1} y1={g.mid} x2={x2} y2={g.mid}
        stroke="#0284C7" strokeWidth="0.5" strokeDasharray="2.5 2.5" opacity="0.7"
      />
      <line x1={x1} y1={g.base} x2={x2} y2={g.base} stroke="#15803D" strokeWidth="0.7" opacity="0.7" />
      <line x1={x1} y1={g.bottom} x2={x2} y2={g.bottom} stroke="#94A3B8" strokeWidth="0.4" opacity="0.4" />

      {/* Letter guide — hand-coded single-line American cursive paths. The
          animator + start dot use these exact same paths so the "Show me"
          pen traces along the visible centerline (no doubled outline). */}
      {showLetter &&
        letter.strokes.map((s, i) => (
          <path
            key={i}
            d={s.d}
            fill="none"
            stroke="#0D9488"
            strokeWidth="3.2"
            strokeLinecap="round"
            strokeLinejoin="round"
            opacity={guideOpacity}
            fillRule="evenodd"
          />
        ))}

      {/* Start dot + directional arrow */}
      {showStart && (
        <g>
          <circle cx={arrow.x} cy={arrow.y} r="3.4" fill="#F59E0B">
            <animate attributeName="r" values="3.4;4.4;3.4" dur="1.3s" repeatCount="indefinite" />
          </circle>
          <circle cx={arrow.x} cy={arrow.y} r="1.5" fill="#fff" />
          <g transform={`translate(${arrow.x} ${arrow.y}) rotate(${arrow.angle})`}>
            <path d="M 5 0 L 11 0 M 9 -2 L 11 0 L 9 2" stroke="#D97706" strokeWidth="1.1" fill="none" strokeLinecap="round" strokeLinejoin="round" />
          </g>
        </g>
      )}
    </g>
  );
}
